import UpcomingGrant from "../../../components/grants/upcoming-grant"

export default function GrantsUpcoming({ title, items = [], children }) {
    return (
        <div className="upcoming-grants">
            <p className="section__title"><img src="/assets/logos/application-activity.svg" />{title} { children !== undefined && children }</p>
            {/*<p className="section__subtitle">Please Hover/Click to see more info</p>*/}
            { children == undefined && <div className="upcoming-grants__grants">
                {
                    items.map((item, index) => {
                        return(
                            <UpcomingGrant key={index} {...item} />
                        );
                    })
                }

            </div>  }
        </div>
    )
}
